// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImagePayload__container-eb66f0 {
  position: relative;
  min-height: var(--media-bubble-min-height);
  background-color: inherit;
}

.ImagePayload__image-ad1a6a {
  min-width: 100%;
  min-height: 100%;
  background-color: var(--base-30);
}

.ImagePayload__image-ad1a6a.ImagePayload__my-image-a45e50 {
  background-color: var(--addition-190);
}

.ImagePayload__icon-b4ef56 {
  fill: var(--addition-50);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/Payload/ImagePayload/ImagePayload.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,0CAAA;EACA,yBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;AACF;;AAEA;EACE,qCAAA;AACF;;AAEA;EACE,wBAAA;AACF","sourcesContent":[".container {\n  position: relative;\n  min-height: var(--media-bubble-min-height);\n  background-color: inherit;\n}\n\n.image {\n  min-width: 100%;\n  min-height: 100%;\n  background-color: var(--base-30);\n}\n\n.image.my-image {\n  background-color: var(--addition-190);\n}\n\n.icon {\n  fill: var(--addition-50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ImagePayload__container-eb66f0`,
	"image": `ImagePayload__image-ad1a6a`,
	"my-image": `ImagePayload__my-image-a45e50`,
	"myImage": `ImagePayload__my-image-a45e50`,
	"icon": `ImagePayload__icon-b4ef56`
};
module.exports = ___CSS_LOADER_EXPORT___;
